import { schema } from "normalizr";
import { CarrierServiceWarehouseService } from "./carrier-service-warehouse-service";

export const CarrierServiceWarehouseServices = new schema.Array(CarrierServiceWarehouseService);
